module.exports = __webpack_public_path__ + "static/media/signup_bottom_left.dd3247a5.png";